// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The document registry token.
 */
export const IDocumentManager = new Token('@jupyterlab/docmanager:IDocumentManager');
//# sourceMappingURL=tokens.js.map